import { useCallback } from "react";

import { ApolloError, isApolloError } from "@apollo/client/errors";
import { logError } from "@hl/shared-features/lib/services/logger";

import { useGetPageUploadUrlMutation } from "../Editor/editor.graphql.generated";
import { EditorNodes } from "../Editor/logic";

export const usePageUpload = ({
  setErrorMessage,
}: {
  setErrorMessage: (msg: string) => void;
}) => {
  const [getPageUploadUrl] = useGetPageUploadUrlMutation();

  const getPageUploadUrlData = useCallback(
    async (node: EditorNodes) => {
      try {
        return (
          await getPageUploadUrl({
            variables: {
              data: {
                mime: node.mediaMime,
                type: node.mediaType,
              },
            },
          })
        ).data;
      } catch (e) {
        await logError({
          e,
          message: "[PublishModal] failed to generate upload URL",
        });
        if (isApolloError(e as Error)) {
          const apolloError = e as ApolloError;
          const TOO_MANY_REQUESTS = 429;
          if (
            apolloError.graphQLErrors[0]?.extensions.status ===
            TOO_MANY_REQUESTS
          ) {
            setErrorMessage(apolloError.message);
            return;
          }
        }
        setErrorMessage("An unexpected error occurred, please try again.");
      }
    },
    [setErrorMessage]
  );

  return {
    getPageUploadUrlData,
  };
};
